import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, setState } from 'react';
import Config from '../../../../Config';
import noImage from './images/no-image.svg';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

//--------------- Swiper ---------------
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper.scss';
import premiumPackageRemarkIcon from './images/premium-package-remark-icon.svg';
import vasIconLeft from './images/vas-icon-left.svg';
SwiperCore.use([Autoplay, Pagination, Navigation]);
//--------------- Swiper ---------------

const PremiumPackagePopup = (props) => {
  const [vasList, setVasList] = useState([]);

  useEffect(() => {
    const vases = props.premiumPackage.vasList.map(x => ({ ...x, isOpen: x.isSelected }));
    setVasList(vases);
  }, []);

  const image = props.premiumPackage.image ? Config.epiBaseUrl + props.premiumPackage.image : noImage;

  return (
    <div className="premium-package-popup">

      <div className='premium-package-image'>
        <Image src={image} alt={props.premiumPackage.title} />

        <div className='premium-package-datails'>
          <div className='title-wrapper'> {props.premiumPackage.title} </div>
          <div className='price-wrapper'>
            <Price price={props.premiumPackage.price} priceText={props.premiumPackage.priceText} vasList={props.premiumPackage.vasList} />
          </div>
        </div>
      </div>

      <div className='premium-channels-wrapper'>
        <div className='channels-title'> הערוצים הכלולים בחבילה </div>
        <div className='channels-wrapper'>
          {
            props.premiumPackage.channelList?.length < 4 ? (
              props.premiumPackage.channelList.map(function (item, index) {
                const channelImage = Config.epiBaseUrl + item.image;
                return (
                  <div className="channel">
                    <div className="channel-image"> <Image src={channelImage} alt={item.name} /> </div>
                    <div className="channel-name"> {item.name} </div>
                  </div>
                );
              })
            ) : (
              <Swiper autoplay={{ delay: 0, disableOnInteraction: false }} slidesPerView='3' speed={4000} centeredSlides loop >
                {
                  props.premiumPackage.channelList.map(function (item, index) {
                    const channelImage = Config.epiBaseUrl + item.image;
                    return (
                      <SwiperSlide key={index}>
                        <div className="channel">
                          <div className="channel-image"> <Image src={channelImage} alt={item.name} /> </div>
                          <div className="channel-name"> {item.name} </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
                }
              </Swiper>
            )
          }
        </div>
      </div>

      <div className="premium-package-text">
        <div dangerouslySetInnerHTML={{ __html: props.premiumPackage.description }}></div>
      </div>

      {
        props.premiumPackage.isMobileSupport == false &&
        <div className="premium-package-remark-wrapper" >
          <div className="premium-package-remark" style={{backgroundImage:premiumPackageRemarkIcon.bg()}}>
            <div className="remark-title"> חשוב לדעת </div>
            <div className="remark"> הצפייה אפשרית בטלוויזיה בלבד ולא במכשיר ניידים (סמארטפון, טאבלט או מחשב נייד) </div>
          </div>
        </div>
      }

      {(props.premiumPackage.vasList.length > 1) && (
        <div className="vas-list-wrapper">
          <div className="vas-list-title"> בחרו את המסלול שמתאים לכם </div>
          {/* <div className="vas-list-sub-title"> אפשר לרכוש חבילות יומיות של ספורט חמש וצ'רלטון בלי להתחייב לכל החודש באזור האישי ובטלוויזיה, לאחר ההצטרפות לשירות </div> */}

          {
            vasList &&
            <div className="vas-list">
              {
                vasList.map(function (vas, index) {
                  return (
                    <div className={`vas-details-wrapper ${vas.isOpen ? 'open' : ''}`} key={vas.id}>

                      <div className="vas-item-wrapper" onClick={() => handleVasDetailsClick(vas.id)}>
                        <div className="text-wrapper"> {vas.title} </div>
                        <div className="price-wrapper">
                          <div className="price">{vas.price} <span>₪</span></div>
                          <div className="price-text">{vas.priceText}</div>
                        </div>
                        <div className="icon-wrapper" style={{backgroundImage:vasIconLeft.bg()}}></div>
                      </div>

                      <div className="vas-details">
                        {vas.durationInDays < 30 && (
                          <div className="vas-remark"> <div dangerouslySetInnerHTML={{ __html: vas.buttonRemark }}></div> </div>
                        )}
                        {vas.isSelected == false && (
                          <div className="vas-button">
                            <BtnSubmit text="בחר והמשך" onclick={() => handleSelectVas(props.premiumPackage.id, vas.id)} formid={0} isBusiness={false} isDisplayArrows={false} />
                          </div>
                        )}
                      </div>

                    </div>
                  );
                })
              }
            </div>
          }
        </div>
      )}

    </div>
  )

  function handleVasDetailsClick(vasId) {

    const newVasList = [...vasList];
    newVasList.map(function (item, index) {
      if (item.id == vasId) {
        item.isOpen = !item.isOpen;
      }
      else {
        item.isOpen = false;
      }
    });
    setVasList(newVasList);
  }

  function handleSelectVas(premiumPackageId, vasId) {
    props.onVasSelected(premiumPackageId, vasId)
  }



}

const Price = (props) => {
  if (props.price == '' || props.price == '0') {
    return (<div className='price'>כלול בחבילה</div>)
  }
  else {
    return (
      <>
        <div className='price'>
          {props.vasList.length > 1 && (
            <span className="price-prefix">החל מ-</span>
          )}
          ₪{props.price}
        </div>
        {props.priceText && props.priceText != '' &&
          <div className='price-text'>{props.priceText}</div>
        }
      </>
    )
  }
}

export default PremiumPackagePopup;